/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Enum from 'galax/enum/route';

import BuildingAttack from 'galax/config/command/building.attack';
import BuildingCreate from 'galax/config/command/building.create';
import BuildingUpgrade from 'galax/config/command/building.upgrade';

import UnitAttack from 'galax/config/command/unit.attack';
import UnitCreate from 'galax/config/command/unit.create';

import SectorTransfer from 'galax/config/command/sector.transfer';
import ZoneFlow from 'galax/config/command/zone.flow';


let Config = {};


Config[Enum.BuildingAttack]      = BuildingAttack;
Config[Enum.BuildingCreateList]  = BuildingCreate;
Config[Enum.BuildingCreateType]  = BuildingCreate;
Config[Enum.BuildingUpgrade]     = BuildingUpgrade;

Config[Enum.UnitAttack]          = UnitAttack;
Config[Enum.UnitCreateList]      = UnitCreate;
Config[Enum.UnitCreateType]      = UnitCreate;

Config[Enum.TransferEdit]        = SectorTransfer;
Config[Enum.ZoneFlow]            = ZoneFlow;


export default Config;
